const DateFormat = (props) => {
  if (props.value !== null && props.value !== '' && props.value !== undefined) {
    const date = props.value.replace('T', ' ').replace('.000Z', '')
    return new Date(date).toLocaleDateString(undefined, {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    })
  } else {
    return ''
  }
}
export default DateFormat
